module.exports = __webpack_public_path__ + "static/media/facebook.20caa7d0.svg";